module.exports = __webpack_public_path__ + "img/SketchPngaa935039c469ee16ac7046ea086c054b4bb9f6bd34ab7d785f53fa5fe07f1f96.90546597.png";